<template>
  <div class="preview_20 flex column">
    <div v-if="fps_t.background.is_configured && fps_t.background.config.type != 'disable'" :style="fps_t.background.config.type == 'color' ? 'background-color: ' + fps_t.background.config.color : 'background-image: url(' + fps_t.background.config.img_url + ')'" class="background"></div>
    <div class="bd top-half_wrp">
      <div class="flex-center mt-hg">
        <div id="running_status" class="status-tag">
          <span class="h6">{{ profile.status }}</span>
        </div>
      </div>
      <div>
        <div class="params flex align-item-center">
          <div class="param flex1">
            <div class="flex align-item-center">
              <f-sensor-icon-small v-if="fps_t['param_0_1'].is_configured" :icons="fps_t['param_0_1']" :is-grey="false" :empty="true"></f-sensor-icon-small>
              <div class="text-light h7">{{ fps_t['param_0_1'].is_configured ? fps_t['param_0_1'].sen.sen_name : fps_t['param_0_1'].title }}</div>
            </div>
            <div class="flex align-item-center justify-content-flex-end" style="margin-right: 10px;">
              <div class="mt-xs h5" v-if="fps_t['param_0_1'].sen && fps_t['param_0_1'].sen.sen_type == 3">
                {{ fps_t['param_0_1'].sen.value ? 'ON' : 'OFF' }}
              </div>
              <div class="mt-xs h6" v-else-if="fps_t['param_0_1'].sen && (fps_t['param_0_1'].sen.sen_type == 2 || fps_t['param_0_1'].sen.sen_type == 4)">
                {{ fps_t['param_0_1'].is_configured ?  fps_t['param_0_1'].sen.value : '- -' }}
              </div>
              <div class="mt-xs h5" v-else>{{ fps_t['param_0_1'].is_configured ?  fps_t['param_0_1'].sen.value : '- -' }} 
                <span class="h8">{{ fps_t['param_0_1'].is_configured ?  fps_t['param_0_1'].sen.unit : '' }}</span>
              </div>
            </div>
          </div>

          <div class="param flex1 ml">
            <div class="flex align-item-center">
              <f-sensor-icon-small v-if="fps_t['param_0_2'].is_configured" :icons="fps_t['param_0_2']" :is-grey="false" :empty="true"></f-sensor-icon-small>
              <div class="text-light h7">{{ fps_t['param_0_2'].is_configured ? fps_t['param_0_2'].sen.sen_name : fps_t['param_0_2'].title }}</div>
            </div>
            <div class="flex align-item-center justify-content-flex-end" style="margin-right: 10px;">
              <div class="mt-xs h5" v-if="fps_t['param_0_2'].sen && fps_t['param_0_2'].sen.sen_type == 3">
                {{ fps_t['param_0_2'].sen.value ? 'ON' : 'OFF' }}
              </div>
              <div class="mt-xs h6" v-else-if="fps_t['param_0_2'].sen && (fps_t['param_0_2'].sen.sen_type == 2 || fps_t['param_0_2'].sen.sen_type == 4)">
                {{ fps_t['param_0_2'].is_configured ?  fps_t['param_0_2'].sen.value : '- -' }}
              </div>
              <div class="mt-xs h5" v-else>{{ fps_t['param_0_2'].is_configured ?  fps_t['param_0_2'].sen.value : '- -' }} 
                <span class="h8">{{ fps_t['param_0_2'].is_configured ?  fps_t['param_0_2'].sen.unit : '' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="conta">
          <template v-for="ind in 3" >
            <div :key="'slide' + ind" class="item-area mr ml mb flex">
              <div class="equip-status">{{ fps_t['pump_status_' + ind].is_configured && checkStatus(fps_t['pump_status_' + ind]) && profile.is_online ? '运行中' : '已停止' }}</div>
              <div class="bd flex-center">
                <img src="@/assets/pump-xg.png" :class="['pump-image' , fps_t['pump_status_' + ind].is_configured && checkStatus(fps_t['pump_status_' + ind]) && profile.is_online && 'animation']" />
              </div>

              <div class="ft flex column align-item-flex-end">
                <div class="bd">
                  <div class="flex">
                    <f-sensor-icon-small v-if="fps_t['param_' + ind].is_configured" :icons="fps_t['param_' + ind]" :is-grey="false" :empty="true"></f-sensor-icon-small>
                    <div>
                      <div class="text-light h6">{{ fps_t['param_' + ind].is_configured ?  fps_t['param_' + ind].sen.sen_name : fps_t['param_' + ind].title }}</div>
                      <div class="mt-xs h5" v-if="fps_t['param_' + ind].sen && fps_t['param_' + ind].sen.sen_type == 3">
                        {{ fps_t['param_' + ind].sen.value ? 'ON' : 'OFF' }}
                      </div>
                      <div class="mt-xs h6" v-else-if="fps_t['param_' + ind].sen && (fps_t['param_' + ind].sen.sen_type == 2 || fps_t['param_' + ind].sen.sen_type == 4)">
                        {{ fps_t['param_' + ind].is_configured ?  fps_t['param_' + ind].sen.value : '- -' }}
                      </div>
                      <div class="mt-xs h5" v-else>{{ fps_t['param_' + ind].is_configured ?  fps_t['param_' + ind].sen.value : '- -' }} 
                        <span class="h8">{{ fps_t['param_' + ind].is_configured ?  fps_t['param_' + ind].sen.unit : '' }}</span>
                      </div>
                      
                    </div>
                  </div>
                </div>

                <div class="ft flex">
                  <div :class="['btn-circle']">
                    <img v-if="fps_t['pump_on_' + ind].is_configured" src="@/assets/button-turnoff.png" class="image sm" />
                    <img v-else src="@/assets/button-turnon.png" class="image sm" />
                  </div>
                </div>

              </div>
            </div>
          </template>
        </div>
        <div class="flex-center mt">
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>

    <div class="ft">
      <div class="flex align-items-center mb" style="justify-content: space-around;">
        <div class="flex-center column operate-item">
          <div class="btn-circle">
            <img src="@/assets/sidebar/event-center-w.svg" class="image" />
          </div>
          <div class="h7 mt-xs text-light">{{ '上线' }}</div>
        </div>
        <div class="flex-center column operate-item">
          <div class="btn-circle">
            <img src="@/assets/sidebar/home-w.svg" class="image" />
          </div>
          <div class="h7 mt-xs text-light">{{ '总览' }}</div>
        </div>
        <div class="flex-center column operate-item">
          <div class="btn-circle">
            <img src="@/assets/sidebar/bibibi-w.svg" class="image" />
          </div>
          <div class="h7 mt-xs text-light">{{ '告警' }}</div>
        </div>
        <div class="flex-center column operate-item">
          <div class="btn-circle">
            <img v-if="fps_t.auto_status.is_configured" src="@/assets/sidebar/auto-w.svg" class="image" />
            <img v-else src="@/assets/sidebar/operate-w.svg" class="image" />
          </div>
          <div class="h7 mt-xs text-light">{{ '模式' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

import 'swiper/css/swiper.css'
export default {
  name: 'Panel19',
  props: {
    fps_t: {
      type: Object,
      default: []
    },
    profile: {
      type: Object
    }
  },
  data() {
    return {
      activeFp: { fpid: null },
      fp_str: null,
    }
  },

  methods: {
    getAFp(flag, fp_str) {
      this.activeFp.fpid = flag;
      this.fp_str = fp_str;
    },
    checkStatus (param) {
      if(param && param.sen){
        var sensor = param.sen;
        switch(sensor.sen_type){
          case 1:
          switch(param.config.trigger_typeid)
            {
              case 1:
                return sensor.value > param.config.max;
              case 2:
                return sensor.value < param.config.min;
              case 4:
                return Number(sensor.value) < param.config.max && Number(sensor.value) > param.config.min;
              case 15:
                return sensor.value == param.config.min
            }
            break;
          case 2:
            return sensor.value == param.config.min;
          case 3:
            return !!Number(sensor.value);
          case 4:
            return sensor.value == param.config.min;
        }
      } else {
        return false
      }
    }
  },
  components: { Swiper, SwiperSlide, FSensorIconSmall: () => import("./FSensorIconSmall.vue") }
}
</script>
<style lang="scss" scoped>
.preview_20 {
  position: relative;
  width: 390px;
  height: 844px;
  margin: 0 auto;
  background-size: 100% 100%;
  color: #fff;
  background-image: linear-gradient(#007BD3, #041F40);
  .background {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    filter: brightness(0.7);
  }
  .top-half_wrp{
    position: relative;
    padding-top: 64px;
    width: 100%;
    .mt-hg{
      margin-top: 30px;
    }
  }

  .params{
    margin-top: 30px;
    padding: 0 15px;
    .param {
      height: 64px;
      padding: 10px;
      background-color: rgba(255, 255, 255, 0.1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
    }
  } 

  .conta {
    position: relative;
    margin-top: 30px;
  }
  .top-half_wrp .item-area{
    position: relative;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 20px 20px;
    .equip-status {
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(255, 255, 255, 0.1);
      padding: 6px 30px;
      text-align: center;
      border-radius:10px 0 10px 0;
    }
    .pump-image {
      margin-top: 25px;
      width: 60px;
      height: 60px;
    }
    .animation {
      animation: rotate 2s linear infinite;
    }

  }
  .swiper-pagination {
    display: flex;
    justify-content: space-around;
    width: 40px;
  }

  .swiper-pagination /deep/.swiper-pagination-bullet-active {
    background: #fff;
  }

  .status-tag {
    background-color: rgba(255, 255, 255, 0.1);
    padding: 10px 20px;
    line-height: 1;
    border-radius: 16px;
    text-align: center;
    border-width: 1px;
  }

  .operate-item {
    margin: 20px;
    z-index: 200;
  }
  .btn-circle{
    background-color: rgba(255, 255, 255, .1);
    padding: 2px;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    margin-top: 5px;
    .image {
      width: 18px;
      height: 18px;
      font-size: 16px;
    }
  }
  .image.mini{
    width: 20px;
    height: 20px;
    font-size: 16px;
  }
  .align-item-flex-end {
    align-items: flex-end;
    text-align: right;
  }
  //无限旋转动画
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
